<!-- menu start-->
<ion-grid>
  <ion-row>
    <ion-col
      class="ion-padding-horizontal ion-padding-top"
      size="12"
      size-xs="12"
      size-md="12"
      size-lg="12"
    >
      <ion-list class="ion-no-padding" lines="none">
        @for (nav of navs(); track nav.route) {
          <ion-item
            class="panel-menu-item"
            (click)="menuItemClick(nav.route)"
            [color]="nav.color"
          >
            {{ nav.label | translate }}
          </ion-item>
        }
      </ion-list>
    </ion-col>
  </ion-row>
</ion-grid>
<!-- menu end-->
